import { autoinject, bindable, computedFrom } from 'aurelia-framework';
import { Device } from "../../../models/device";
import { applicationLogger } from "../../../logging/logger";
import { TemperatureBaseDevice } from "./temperature-base-device";
import { Store } from "aurelia-store";
import * as State from "../../../store/state";
import IState = State.IState;
import { Api } from "../../../services/api";
import { I18N } from "aurelia-i18n";


@autoinject
export class MilesiteUC501AquaCheckmoisture extends TemperatureBaseDevice {
	@bindable humidity;
	

	constructor(store: Store<IState>, api: Api, i18n: I18N ) {
		super(store, api, i18n);
	}

	activate(device: Device) {
		applicationLogger.debug(`${MilesiteUC501AquaCheckmoisture.name}.activate() called.`);
		this.device = device;

	
	}

	@computedFrom('device.data')
	get averageMoisture(): number {
		return this.calculateAverageMoisture();
	}


	@computedFrom('device.data')
	get maximumMoisture(): number {
		return this.findMaximumMoisture();
	}

	@computedFrom('device.data')
	get medianMoisture(): number {
		return this.findMedianMoisture();
	}

	findMedianMoisture(): number {


		if (this.device === undefined || this.device === null || this.device.data === undefined || this.device.data == null) {
			return null;
		}

		var data = this.device.data;
		const numbers: number[] = [];
		
		if (data.moisture1 != 0.0) {
			numbers.push(data.moisture1);
		};

		if (data.moisture2 != 0.0) {
			numbers.push(data.moisture2);
		}

		if (data.moisture3 != 0.0) {
			numbers.push(data.moisture3);
		}

		if (data.moisture4 != 0.0) {
			numbers.push(data.moisture4);
		};

		if (data.moisture5 != 0.0) {
			numbers.push(data.moisture5);
		};

		if (data.moisture6 != 0.0) {
			numbers.push(data.moisture6);
		};

		if (data.moisture7 != 0.0) {
			numbers.push(data.moisture5);
		};

		if (data.moisture8 != 0.0) {
			numbers.push(data.moisture6);
		};

		// Sort the array in ascending order
		numbers.sort((a, b) => a - b);

		const length = numbers.length;
		const middle = Math.floor(length / 2);

		// Check if the array length is even or odd
		if (length % 2 === 0) {
			// If even, return the average of the two middle elements
			return (numbers[middle - 1] + numbers[middle]) / 2;
		} else {
			// If odd, return the middle element
			return numbers[middle];
		}
	}

	private findMaximumMoisture(): number {


		if (this.device === undefined || this.device === null || this.device.data === undefined || this.device.data == null) {
			return null;
		}

		var data = this.device.data;
		const numbers: number[] = [data.moisture1, data.moisture2, data.moisture3, data.moisture4, data.moisture5, data.moisture6, data.moisture7, data.moisture8];
		const max: number = Math.max(...numbers);

		return max;
	}

	private calculateAverageMoisture(): number {
		if (this.device === undefined || this.device === null || this.device.data === undefined || this.device.data == null) {
			return null;
		}

		var data = this.device.data;
		var measureCount = 0;
		var moisture = 0.0;

		if (data.moisture1 != null && data.moisture1 != 0.0) {
			moisture += data.moisture1;
			measureCount++;
		}

		if (data.moisture2 != null && data.moisture2 != 0.0) {
			moisture += data.moisture2;
			measureCount++;
		}
		if (data.moisture3 != null && data.moisture3 != 0.0) {
			moisture += data.moisture3;
			measureCount++;
		}
		if (data.moisture4 != null && data.moisture4 != 0.0) {
			moisture += data.moisture4;
			measureCount++;
		}
		if (data.moisture5 != null && data.moisture5 != 0.0) {
			moisture += data.moisture5;
			measureCount++;
		}
		if (data.moisture6 != null && data.moisture6 != 0.0) {
			moisture += data.moisture6;
			measureCount++;
		}

		if (data.moisture7 != null && data.moisture7 != 0.0) {
			moisture += data.moisture7;
			measureCount++;
		}
		if (data.moisture8 != null && data.moisture8 != 0.0) {
			moisture += data.moisture6;
			measureCount++;
		}


		return measureCount > 0 ?  moisture/measureCount : moisture;
	}

	@computedFrom('device.data')
	get averageTemperature(): number {
		return this.device != null && this.device.data != null ? (this.device.data.temperature1 + this.device.data.temperature2 + this.device.data.temperature3 + this.device.data.temperature4 + this.device.data.temperature5 + this.device.data.temperature6) / 6 : null;
	}

	attached() {
		if (this.tooltip) {
			this.tooltip.html = this.buildToolTip();
		}
	}

}